import { imgReport } from './util';
import { elk, getELkObj, setElkBusinessName, setElkEnv } from './libs/elk';
import { acc, setAccBusinessName, setAccEnv, setAccModule } from './libs/acc';
import { getItemSync, setItemSync } from './cache';
import { init as mtaInit, setCurPageName } from './libs/mta'
import { initGlobalErrorReport, CustomException } from './error';
import { paramsToObject} from './util';
import { initFullReport } from './libs/full-report'

let businessName = "unknow";
let release = 'release'; //elk每次更新都会有release,把这个作为版本标识

function setBusinessName(name){
    businessName = name
    setElkBusinessName(name);
}

function itil(id) {
    // 暂时使用话费能力
    imgReport(`//chong.qq.com/node/product?c=data_collector&m=reportItil&itilId=${id}`);
}

let hasReportIndexPvUvAndTimeCost = false;
/**
 * 上报首页pv/uv，耗时，机型，到elk
 */
function reportIndexPvUvAndTimeCost(){
    if(hasReportIndexPvUvAndTimeCost){
        return;
    }
    const pageStartTime = window.__$$_pageStartTime;
    if(!pageStartTime){
        throw new CustomException(null, 'PageStartTimeNullException', 'in base-libs/report.js, window.__$$_pageStartTime is required!');
    }
    const timeDiff = new Date().getTime() - pageStartTime; //耗时
    const isTwiceLoad = getItemSync(`${businessName}_${release}_index_loaded`);
    let key = 'index_firstLoad';
    if(isTwiceLoad === '1'){
        key = 'index_twiceLoad';
    }
    //str1：后续可以用于做各个应用首页耗的对比，pv/uv的对比 str1:"pv_uv_report" , average:time_diff, split: channel
    const str1 = 'index_pv_uv_report';
    const str4 = release;
    const brandAndSystem = getBrandAndSystem();
    const { brand, system } = brandAndSystem;
    const str2 = brand;
    const str3 = system;
    acc({
        /* service */
        service: str1,
        ext1: key
    });
    elk({
        key,
        str1,
        str2,
        str3,
        str4,
        timeDiff
    });
    hasReportIndexPvUvAndTimeCost = true;
    try{
        //记录首次加载
        setItemSync(`${businessName}_${release}_index_loaded`, '1', 1000*60*60*24*365*5);
    }catch(err){
        elk({
            key: 'localstorage.setItem error'
        });
    }
}


/**
 * 获取机型信息
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
function getBrandAndSystem() {
    let brand = '';
    let system = '';
    try {
      const ua = window.navigator.userAgent;
      const isIphone = /iPhone/.test(ua);
      const isAndroid = /Android/.test(ua);    
      const infoSplit = ua
        .match(/^.*?(\(.*?\)).*$/)[1]
        .replace(/[()]/g, '')
        .split(';');
  
      if (isIphone) {
        brand = infoSplit[0].trim();
        system = infoSplit[1].trim();
      }
  
      if (isAndroid) {
        brand = infoSplit[2].trim();
        system = infoSplit[1].trim();
      }
    } catch (err) {
      
    }
    return {brand, system};
  }
  
/**
 * 获取vue-router中配置的中文名
 */
function getCnName(routes, path){
    let pageCfg = routes.find(item=>item.path===path);
    if(!pageCfg){
        //因为router中可能有path:"*"的配置
        pageCfg = routes.find(item=>item.path==="*");
    }
    let cnname = '';
    if(pageCfg && pageCfg.cnname){
        cnname = pageCfg.cnname;
    }
    return cnname;
}

/**
 * 上报每个页面停留时间
 * 顺带上报页面pvuv
 */
function reportPageStayedTime(router){
    //如果不存在vue router，就不上报页面耗时，业务自己搞把
    if(!router || !router.options  || !router.options.routes){
        return;
    }
    const routes = router.options.routes;
    //const pagePath = router.currentRoute.path;
    const pageTimeMap = {};
    // str1：后续可以用于做各个应用页面的耗时对比， str1:"page_time_cost_report" , average:time_diff, split: channel
    const str1 = 'page_time_cost_report';
    router.beforeEach((to, from, next) => {
        let fromPath = from.name || from.path;
        let toPath = to.name || to.path;

        if(toPath === '/'){
            toPath = 'index';
        }
        toPath = toPath.replace(/^\//, ''); //移除开头的/

        if(fromPath === '/'){
            fromPath = 'index';
        }
        fromPath = fromPath.replace(/^\//, ''); //移除开头的/

        toPath = toPath.toLowerCase();
        fromPath = fromPath.toLowerCase();
        
        if (pageTimeMap[fromPath]) {
            const timeDiff = new Date().getTime() - pageTimeMap[fromPath].startTime;
            const key = fromPath;
            const str2 = getCnName(routes, key); //页面中文名上报
            elk({
                key,
                str1,
                str2,
                timeDiff,                
            });
            
            //上报bi,pvuv 2020-11-19干掉pv/uv上报
            //biHottag(`${businessName}.page_${toPath}.timeStay`, {ftimestay: timeDiff});
        }
        pageTimeMap[toPath] = {
            startTime: new Date().getTime(),
        };
        acc({
            /* service */
            service: `${businessName}.page_${toPath}.pvuv`,
        });
        setCurPageName(toPath); //设置当前页面名称
        //pgv(); //上报pv/uv 2020-11-19干掉pv/uv上报
        next();
    });
    //当页面被关闭当时候，进行一次上报
    window.addEventListener('unload', () => {
        const currentPath = router.currentRoute.path;
        if (pageTimeMap[currentPath]) {
            const key = currentPath;
            const timeDiff = new Date().getTime() - pageTimeMap[currentPath].startTime;
            const str2 = getCnName(routes, key);  //业务中文名上报
            elk({
                key,
                str1,
                str2,
                timeDiff,
            });
        }
    });
}

/**
 *
 elk调用实例：
 字段跟elk的字段一致：
 uin、channel、url会自动获取，也可以覆盖
 数组、对象类型都会转字符串 不用自己转
 url、body、msg会自动encode

 elk({
    errCode: res && res.response && res.response.status,
    msg: data,
    url: config.url,
    body: config.data || '',
    key: 'ajaxError'
});
 */


 /**
  * cgi模版直出数据上报
  */
 function cgiTemplateDataReport(){
     const data = window.cgiTemplateData;
     const url = location.pathname;
     const urlMatch = url.match(/\/([\w-]*\.f?cgi)[^-]*/);
     const cgiName = urlMatch ? urlMatch[1] : 'ajax';
     elk({
         msg: data,
         url: url,
         body: paramsToObject(location.search || ''),
         key: cgiName,
        //  timeDiff: new Date().getTime() - startTime,
         str2: 'template'
     });
 }

/**
 * 初始化上报
 * @param {*} option 
 */
function initReport(option, Vue){
    const { business, appEnv, isReportPageStayedTime, router, accModule, sentry, isOpenFullReport } = option;
    
    setElkEnv(appEnv);
    setAccEnv(appEnv);

    //初始化elk上报business name , 对应的是channel字段
    setBusinessName(business);
    //初始化Acc上报business name , 对应的是server字段
    setAccBusinessName(business);
    // 初始化全埋点上报
    const isFull = isOpenFullReport || false;
    initFullReport(business, isFull);
    
    if(accModule){
        setAccModule(accModule);
    }

    //上报页面停留时间
    if(isReportPageStayedTime){
        reportPageStayedTime(router);
    }

    //全局sentry错误上报, 自定义异常上报
    if(option.sentry && option.sentry.dsn && option.sentry.release){
        release = option.sentry.release;
        initGlobalErrorReport({
            appEnv: appEnv,
            business: business,
            sentry: sentry,
        }, Vue);
    }

    //bi上报
    if(option.bi){
        // 初始化mta
        mtaInit({
            source: business, 
            reportNeedLogin: typeof option.bi.reportNeedLogin !== 'undefined' ? option.bi.reportNeedLogin : true,
            sid: option.bi.sid, //可不填，用默认的
            cid: option.bi.cid, //可不填，用默认的
            noAdtag: option.bi.noAdtag || false, //可不填，用默认的
            domain: option.bi.domain  //可不填，用默认的
        });
    }

    //如果有模版数据，需要上报模版数据
    if(window.cgiTemplateData){
        //template数据上报
        cgiTemplateDataReport();
    }

    //页面离开时触发上报，标示是最后一个上报
    window.addEventListener('unload', () => {
        elk({
          key: 'page_unload',
          str2: 'unload',
        });
    });

 }

export { itil, elk, acc, getELkObj, initReport, reportIndexPvUvAndTimeCost };